const SafeAreaConfig = {
  SafeAreaInsetIPhoneX: {
    top: {
      height: 44
    },
    right: null,
    bottom: {
      height: 34
    },
    left: null
  },
  SafeAreaInsetIPhone: {
    top: {
      height: 20
    },
    right: null,
    bottom: null,
    left: null
  }
};

const SafeAreaInsetDefault = {
  top: null,
  right: null,
  bottom: null,
  left: null
};

export const safeAreaInset = function (position, type) {
  const configKey = `SafeAreaInset${type}`;
  const configValue = SafeAreaConfig[configKey] || SafeAreaInsetDefault;
  return configValue[position + ''] || null;
};
